// libs
import React, { memo } from "react";
import styled from "@emotion/styled";
// components
import {
    getAllSubcatories,
    getBigImage,
} from "shared/components/Header/DesktopHeader/components/Menu/helpers";
import BigImage from "shared/components/Header/DesktopHeader/components/Menu/components/BigImage";
import SubCategories from "./components/SubCategories";

// defs
import { IMapOfString } from "global";
interface ISubmenuProps {
    data: IMapOfString;
}

const Container = styled.div`
    padding: 17px 35px 9px 30px;
    display: flex;
`;

function SubMenu({ data }: ISubmenuProps) {
    const subCategoriesData = getAllSubcatories(data);
    const bigImageData = getBigImage(data);
    return (
        <Container>
            <SubCategories data={subCategoriesData} />
            {bigImageData && (
                <BigImage data={bigImageData} position={subCategoriesData.length + 1} />
            )}
        </Container>
    );
}

export default memo(SubMenu);
